export function formatRemaining(ms: number): string {
  // Round up so the label reaches "0 sec" exactly at expiry, not a beat early.
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes > 0) {
    return `${minutes} min ${seconds} sec`
  }
  return `${seconds} sec`
}
